export default __webpack_public_path__ + "static/media/icon-next-dark.d924f693.svg";